import React, { forwardRef } from 'react';

interface LocationProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const Location = forwardRef<HTMLElement, LocationProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-location-dot ${classes || ''}`} style={style}></i>
  );
});

Location.displayName = 'Location';
